import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Loading from '../components/loading';
import useUser from '../queries/user';

const ManagedRoute = ({ component: Component, isPrivate, ...rest }) => {
  const { user, isLoading } = useUser();
  let RenderComponent;
  if (isPrivate) {
    RenderComponent = (
      <Route
        {...rest}
        render={(props) =>
          user ? <Component {...props} /> : <Redirect to="/login" />
        }
      />
    );
  } else {
    RenderComponent = (
      <Route
        {...rest}
        render={(props) =>
          !user ? <Component {...props} /> : <Redirect to="/" />
        }
      />
    );
  }
  return !isLoading ? <>{RenderComponent}</> : <Loading />;
};

ManagedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isPrivate: PropTypes.bool,
};
export default ManagedRoute;
